import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-not-authenticated',
    templateUrl: './not-authenticated.component.html',
    styleUrls: ['./not-authenticated.component.scss'],

    imports: [
        CommonModule,
        FormsModule,
    ],

    providers: [
    ]
})
export class NotAuthenticatedComponent implements OnInit {

    constructor() {
        //
    }

    ngOnInit(): void {
        //
    }

}